import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import styled from "styled-components";
import Button from "../../../Common/Components/Button";
import Checkbox from "../../../Common/Components/Checkbox";
import whiteRoy from "../../../../assets/img/icons/whiteRoy.svg";
import { useState } from "react";
import { useEffect } from "react";
import { closeOverlay, openOverlay, setConfirmBoxBackOverlay } from "modules/GlobalActions";
import { gillRoyMoveDown } from "modules/Content/DragnDrop/actions";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import FloatingNewListAsider from "../Lists/FloatingNewListAsider";
import { getAudienceListsNamesOnlyService } from "modules/Services/AudienceService";
import { AUDIENCE_LISTS } from "constants/types";

interface IDeleteSelected {
  selectedCount?: number;
  loading?: boolean;
  deleteSuccess?: boolean;
  selectAll?: boolean;
  selectAllList?: boolean;
  deleteAllFlag?: boolean;
  checkedItems?: any[];
  deleteAllTotalCount?: number;
  contactsInList?: boolean;
  checkedItemsNewList?: any[];
  inProfiled?: boolean;
  peopleTab?: string;
  unselectedContactIdsState?: any[];
  onClearSelection?: (value: any) => void;
  onDeleteHandler?: (value?: any) => void;
  selectedOrganization?: string[];
  selectedDesignation?: string[];
  selectedPersonality?: string[];
  selectedStatus?: string[];
  permanentDeleteHandler?: () => void;
}

const DeleteSelected: React.FC<IDeleteSelected> = (props) => {
  const {
    loading,
    deleteSuccess,
    selectedCount,
    selectAll,
    selectAllList,
    deleteAllFlag,
    checkedItems,
    deleteAllTotalCount,
    contactsInList,
    checkedItemsNewList,
    inProfiled,
    unselectedContactIdsState,
    peopleTab,
    onDeleteHandler,
    onClearSelection,
    selectedOrganization,
    selectedDesignation,
    selectedPersonality,
    selectedStatus,
    permanentDeleteHandler,
  } = props;
  const [confirm, setConfirm] = useState(false);
  const [contactsFromPeople, setContactsFromPeople]: any[] = useState([]);
  const [permanentDeleteContact, setPermanentDeleteContact] = useState(false);
  const [permanentDeleteContactConfirm, setPermanentDeleteContactConfirm] = useState(false);
  const totalCount = useSelector((state: RootState) => state.peopleAudience.totalCount);
  const totalCountList = useSelector((state: RootState) => state.audienceListDetails.totalContacts);
  const listDataNames: any = useSelector((state: RootState) => state.audienceLists.listsDataNames);

  const tab = window.location.pathname.startsWith("/audiences/people") ? "peopleTab" : "listsTab";

  // useEffect(() => {
  //   console.log("DELETE ALL: ", deleteAllFlag);
  //   console.log("SELECT ALL: ", selectAll);
  //   console.log("TOTAL COUNT: ", totalCount);
  //   console.log("SELECTED COUNT: ", selectedCount);
  //   console.log("TOTAL COUNT DELETE ALL: ", deleteAllTotalCount);
  // }, [deleteAllFlag, selectAll, selectedCount]);

  const deleteHandler = () => {
    setConfirm(true);
    setConfirmBoxBackOverlay(true);
  };

  const permanentDelete = () => {
    setConfirm(true);
    setConfirmBoxBackOverlay(true);
    setPermanentDeleteContact(true);
  }

  const onConfirm = () => {
    if (onDeleteHandler) onDeleteHandler();
    onCancel();
  };

  const onCancel = () => {
    setConfirm(false);
    setConfirmBoxBackOverlay(false);
    setPermanentDeleteContact(false);
    setPermanentDeleteContactConfirm(false);
  };

  const onConfirmDelete = () => {
    if (permanentDeleteContact) {
      setPermanentDeleteContactConfirm(true);
      setConfirm(true);
      setConfirmBoxBackOverlay(true);
      setPermanentDeleteContact(false);
    }
    else if (permanentDeleteContactConfirm) {
      permanentDeleteHandler && permanentDeleteHandler();
      setPermanentDeleteContactConfirm(false);
      onCancel();
    }
  }

  // for adding any messages when delete success of fail
  useEffect(() => {
    if (deleteSuccess) {
      setConfirm(false);
    }
  }, [deleteSuccess]);

  useEffect(() => {
    if (selectedCount === 0 && confirm) {
      setConfirm(false);
      setConfirmBoxBackOverlay(false);
    }
  }, [selectedCount]);


  useEffect(() => {
    const node = document.querySelector(".body-element");
    if (node) {
      if (selectedCount === 0 && node.classList.contains('gillRoy-index')) {
        node.classList.remove("gillRoy-index");
      } else if (selectedCount !== 0) {
        node.classList.add("gillRoy-index");
      }
    }
  }, [selectedCount])

  useEffect(() => {
    if (confirm) document.body.classList.add("delete-contact-confirm-popover");
    else document.body.classList.remove("delete-contact-confirm-popover");
  }, [confirm]);

  useEffect(() => {
    return () => {
      // dropping down gillRoy when unmount
      gillRoyMoveDown();
      onCancel();
    };
  }, []);

  const createNewListHandler = () => {
    store.dispatch({
      type: AUDIENCE_LISTS.NAMES_LOAD,
    });
    getAudienceListsNamesOnlyService()
      .then((res) => {
        store.dispatch({
          type: AUDIENCE_LISTS.NAMES_LOAD_SUCCESS,
          listsDataNames: res.data.lists,
        });
      })
      .catch((err) => {
        store.dispatch({
          type: AUDIENCE_LISTS.NAMES_FAIL,
        });
      });
  };

  // console.log('checkedItemsNewList: ', checkedItemsNewList);
  let DELETE_TEXT = window.location.pathname === "/audiences/lists/view" ? "Remove" : "Delete";
  let CONFIRM_BUTTON_TEXT = window.location.pathname === "/audiences/lists/view" ? permanentDeleteContact ? "Delete" : permanentDeleteContactConfirm ? "Ok" : "Confirm" : "Confirm";
  let CANCEL_BUTTON_TEXT = window.location.pathname === "/audiences/lists/view" ? permanentDeleteContact || permanentDeleteContactConfirm ? "Discard" : "Cancel" : "Cancel";
  let CONFIRMATION_MESSAGE =
    window.location.pathname === "/audiences/lists/view"
      ? `Removing the selected contact(s) will remove them from the list and they will no longer receive any emails sent to this list.`
      : `Deleting the selected contact(s) will permanently delete them from your Audience. Are you sure you want to proceed?`;
  let onListPage = window.location.pathname.includes("lists");

  return (
    <Wrapper
      className={`${(selectedCount && selectedCount > 0) || deleteAllFlag ? "move-up" : ""
        } floating-footer d-flex justify-content-between`}
    >
      {confirm ? (
        <DialogWrapper>
          <div className="back-overlay" />
          <ConfirmDialog
            cancel={CANCEL_BUTTON_TEXT}
            confirm={CONFIRM_BUTTON_TEXT}
            onConfirm={permanentDeleteContact || permanentDeleteContactConfirm ? onConfirmDelete : onConfirm}
            onCancel={onCancel}
            icon={whiteRoy}
            title={permanentDeleteContact ? "Deleting the selected contact(s) will permanently delete them from your Audience. Are you sure you want to proceed?" : permanentDeleteContactConfirm ? `${deleteAllFlag && !selectAll ? deleteAllTotalCount
              : selectAll
                ? totalCount
                : selectAllList
                  ? totalCountList
                  : selectedCount} contact(s) will be permanently deleted from all lists and your Workbench Audience.` : CONFIRMATION_MESSAGE}
            // title={`${deleteAllFlag && !selectAll
            //   ? deleteAllTotalCount
            //   : selectAll
            //     ? totalCount
            //     : selectAllList
            //       ? totalCountList
            //       : selectedCount
            //   }
            //  contact${selectedCount && selectedCount > 1 ? "s?" : "?"}
            // ${loading ? "Deleting..." : ""}
            // `}
            titleQuestion={null}
          />
        </DialogWrapper>
      ) : null}
      {/* Toggle Class sidbar-opend  */}
      <div className="d-flex align-items-center">
        <div className="multi-select">
          <Checkbox checked={true} readOnly />
          <Checkbox checked={true} readOnly />
        </div>
        <span className="count" data-id="qa-list-count-selected" style={{ display: "inline-flex" }}>
          {deleteAllFlag && !selectAll
            ? deleteAllTotalCount
            : selectAll
              ? totalCount
              : selectAllList
                ? totalCountList
                : selectedCount}{" "}
          {selectedCount === 1 ? "contact" : "contacts"} selected
        </span>
        <span className="clear" {...(onClearSelection ? { onClick: onClearSelection } : {})}>
          Clear selection
        </span>
      </div>
      <div className="d-flex align-items-center">
        <FloatingNewListAsider
          tab={tab}
          inList={true}
          similarContacts={checkedItemsNewList}
          selectAllFlag={deleteAllFlag}
          // inProfiled={inProfiled}
          unselectedContactIdsState={unselectedContactIdsState}
          deleteAllTotalCount={deleteAllTotalCount}
          selectAll={selectAll}
          selectAllList={selectAllList}
          selectedCount={selectedCount}
          deleteAllFlag={deleteAllFlag}
          peopleTab={peopleTab}
          selectedOrganization={selectedOrganization}
          selectedDesignation={selectedDesignation}
          selectedPersonality={selectedPersonality}
          selectedStatus={selectedStatus}
          idprefix="dynamic-list"
        >
          <span className="create-list" onClick={createNewListHandler}>
            {onListPage ? "Add to another List" : "Add to List"}
          </span>
        </FloatingNewListAsider>
        <Button
          value={`${DELETE_TEXT}`}
          className={`btn-sm-primary align-self-center ${loading ? "disabled" : ""}`}
          onClick={deleteHandler}
        />
        {
          onListPage ?
            <Button
              value={"Delete"}
              className={`btn-sm-primary align-self-center ${loading ? "disabled" : ""} ${onListPage ? "btn-color list-footer-button" : ""}`}
              onClick={permanentDelete}
            /> : <> </>
        }
      </div>
    </Wrapper>
  );
};

export default DeleteSelected;

const Wrapper = styled.div`
  z-index: 1;
  transition: 1s;
  .create-list {
    font-family: "Roboto";
    font-weight: 500;
    font-size: 16px;
    color: #1ec252;
    cursor: pointer;
    margin-right: 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  &.floating-footer {
    z-index: 7;
    transition: 1s;
    background: #fff;
    border-top: 1px solid #e7e7e7;
    &.move-up {
      bottom: 0 !important;
      box-shadow: 0px -13px 10px rgb(0 0 0 / 10%);
    }
    position: fixed;
    bottom: -86px;
    left: 89px;
    width: calc(100% - 88px);
    padding: 20px 30px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
      left: 64px;
    }
    &.sidbar-opend {
      width: calc(100% - 634px);
    }
    .count {
      color: #7e7e7e;
      font-family: "Roboto Slab", serif;
      font-size: 18px;
      font-weight: 500;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
    }
    .clear {
      cursor: pointer;
      color: #27ce0a;
      font-size: 12px;
      font-weight: 400;
      font-family: "Roboto Slab", serif;
      padding-left: 6px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
      }
    }
    .multi-select {
      position: relative;
      width: 35px;
      height: 45px;
      > div {
        position: absolute;
        top: 10px;
        left: 0;
        z-index: 9;
        span {
          background-color: #fff;
        }
        + div {
          top: 15px;
          left: 5px;
          z-index: 8;
        }
      }
    }
  }
  .list-footer-button{
    margin-left: 10px;
  }
  .btn-color{
    background: #FFFFFF;
    border: 1px solid #7E7E7E;
    color: #7E7E7E;
  }
`;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;
